<template>
  <div class="option a-text" @click="$emit('click')">
    <v-icon size="20px" :color="iconColor">
      {{ icon }}
    </v-icon>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    iconColor: {
      type: String,
      default: "secondary",
    },
    textColor: String,
  },
};
</script>

<style scoped>
.option {
  display: flex;
  gap: 10px;
  cursor: pointer;
}
</style>